import React from "react";

export default function Hero() {
  return (
    <header className="hero" id="top">
      <div className="hero-noise-tile" />
      <div className="steam s1" />
      <div className="steam s2" />
      <div className="steam s3" />
      <div className="wrap hero-inner">
        <span className="hero-kicker">Shoreditch, London · Est. 2016</span>
        <h1 className="hero-title">
          Coffee, <em>kebap</em>
          <br />&amp; curry.
        </h1>
        <p className="hero-sub">
          Cloud9 is a Turkish grill, an Indian kitchen and a coffee house, run out of one small
          room by two families who couldn't agree on whose food to serve — so they serve it all.
        </p>
        <div className="hero-actions">
          <a href="#reserve" className="btn btn-solid">
            Reserve a table
          </a>
          <a href="#menu" className="btn btn-outline">
            See the menu
          </a>
        </div>
      </div>
      <div className="hero-scroll">
        <span className="line" /> Scroll
      </div>
    </header>
  );
}
